import { GAME_MODES, GAME_STATUSES } from '@blind-kings/game-core';

/** Keep in sync with aws-blocks/lib/live-sync.ts */
export const ONLINE_STARTED_POLL_INTERVAL_MS = 4000;

const ONLINE_MODES = new Set<string>([
  GAME_MODES.ONLINE_GAME,
  GAME_MODES.RANKED_GAME,
]);

/** Local and AI apply locally; finished matches do not need a live room. */
export function needsLiveGamePoll(
  gameMode: unknown,
  status: unknown
): boolean {
  if (!ONLINE_MODES.has(String(gameMode ?? ''))) return false;
  const st = String(status ?? '');
  return st === GAME_STATUSES.QUEUED || st === GAME_STATUSES.STARTED;
}
